import {FormLabel} from "./FormLabel";
import {RadioGroup} from "./RadioGroup";
import {Radio} from "./Radio";

interface OptionsFormProps {
    id: string;
    name: string;
    options: {label?: string; value?: string}[];
    value: string;
    onChange: (e: {target: {value: string}}) => void;
    onFocus?: (e: any) => void;
    onOptionFocus?: () => void;
    onBlur?: (e: any) => void;
}

export const OptionsForm = ({
    name,
    options,
    value,
    onChange,
    onFocus,
    onOptionFocus,
    onBlur,
}: OptionsFormProps) => (
    <FormLabel value={name}>
        <RadioGroup
            value={value}
            onChange={(val) => onChange({target: {value: val}})}
            options={options.map((o) => o.value ?? "")}
        >
            {options.map((opt) => (
                <Radio
                    key={opt.value ?? opt.label}
                    value={opt.value ?? ""}
                    name={opt.label ?? opt.value ?? ""}
                    onBlur={onBlur}
                    onFocus={onOptionFocus ?? onFocus}
                />
            ))}
        </RadioGroup>
    </FormLabel>
);
